module.exports = "<div class=\"row\">\n    <div class=\"col-md-12\">\n        <qdt-component [Component]=\"'QdtViz'\" [props]=\"viz1props\"></qdt-component>\n    </div>\n</div>\n<div class=\"row\">\n    <div class=\"col-md-12\">\n        <qdt-component [Component]=\"'QdtViz'\" [props]=\"viz2props\"></qdt-component>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/performance/performance.component.html
// module id = ./src/app/components/performance/performance.component.html
// module chunks = main